/* global axios */
import ApiClient from '../ApiClient';

// Sobe um arquivo (imagem/áudio/vídeo/arquivo) e devolve uma URL utilizável.
// Reaproveita o endpoint genérico POST /api/v1/accounts/:id/upload, que
// responde { file_url, blob_key, blob_id }.
class MediaUploadAPI extends ApiClient {
  constructor() {
    super('upload', { accountScoped: true });
  }

  upload(file) {
    const form = new FormData();
    form.append('attachment', file);
    return axios.post(this.url, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new MediaUploadAPI();
